import React, { Component } from "react";
import firebase from "firebase/app";
import "firebase/auth";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Form } from "informed";
import { TextInput, SelectInput, CheckBox } from "../shared/Forms";
import WordMark from "../../assets/img/event-app-logo-E.png";

class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			existing: true,
			formData: {},
			error: null,
			getUserInfo: false,
			user: {
				timeZoneId: "America/Chicago",
			},
		};
	}

	logInWithGoogle = () => {
		var provider = new firebase.auth.GoogleAuthProvider();
		firebase
			.auth()
			.signInWithPopup(provider)
			.then(() => {
				if (!this.state.existing) {
					localStorage.setItem("newUser", "google");
				}
			});
	};

	signInWithEmail = () => {
		let email = this.state.formData.email;
		let password = this.state.formData.password;
		if (this.state.existing) {
			firebase
				.auth()
				.signInWithEmailAndPassword(email, password)
				.then(result => {
					console.log("Existing User Signed In");
					console.log(result);
				})
				.catch(error => {
					// Handle Errors here.
					var errorMessage = error.message;
					this.setState({ error: errorMessage });
				});
		} else {
			//new user
			this.setState({ getUserInfo: true });
		}
	};

	createNewUserEmail = values => {
		localStorage.setItem("activateUser", JSON.stringify(values));
		let email = this.state.formData.email;
		let password = this.state.formData.password;
		firebase
			.auth()
			.createUserWithEmailAndPassword(email, password)
			.then(result => {
				console.log("New User Created");
				console.log(result);
				localStorage.setItem("newUser", "email");
			})
			.catch(error => {
				// Handle Errors here.
				var errorCode = error.code;
				var errorMessage = error.message;
				if (errorCode === "auth/weak-password") {
					this.setState({ error: "The password is too weak" });
				} else {
					this.setState({ error: errorMessage });
				}
			});
	};

	onChange = formState => {
		this.setState({ formData: formState.values, error: null });
	};

	render() {
		const timezoneOptions = [];
		if (this.props.timezones) {
			this.props.timezones.forEach(timezone => {
				timezoneOptions.push({
					key: timezone.id,
					value: timezone.id,
					label: timezone.name,
				});
			});
		}
		return (
			<div className="log-in-window sign-in star-bg">
				<div className="log-in-window-content">
					<div className={`on-boarding-step on ${this.state.getUserInfo ? "out" : ""}`}>
						<div className="on-boarding-wrap">
							<div className="on-boarding-box box box-with-footer" style={{ width: "300px" }}>
								<div>
									<img
										src={WordMark}
										alt="Event App by Brushfire"
										style={{ maxWidth: "250px", padding: "25px 0 25px 0" }}
									/>
									{this.state.error && <div className="alert alert-danger">{this.state.error}</div>}
									<div>
										<Form onChange={this.onChange} onSubmit={this.signInWithEmail}>
											<TextInput field="email" id="email" placeholder="Email Address" />
											<TextInput
												field="password"
												id="password"
												placeholder="Password"
												type="password"
											/>
											<button type="submit" className="btn btn-primary wide">
												<div
													className={`line-switch${!this.state.existing ? " on" : ""}`}
													style={{ height: "20px" }}
												>
													<div className="line-switch-top">Log In</div>
													<div className="line-switch-bottom">Next</div>
												</div>
											</button>
										</Form>
										<div className="p-top p-bottom">
											<div onClick={this.logInWithGoogle} className="btn login-option">
												<i className="fab fa-google"></i>
											</div>
										</div>
									</div>
								</div>
								<div className="box-footer p-0">
									<h5
										className="page-title box-footer-btn"
										onClick={() => this.setState({ existing: !this.state.existing })}
									>
										<div className={`line-switch${!this.state.existing ? " on" : ""}`}>
											<div className="line-switch-top">Or Sign Up</div>
											<div className="line-switch-bottom">
												<i className="fal fa-chevron-left"></i> Log In
											</div>
										</div>
									</h5>
								</div>
							</div>
						</div>
					</div>
					<div className={`on-boarding-step ${this.state.getUserInfo ? "on" : ""}`}>
						<div className="on-boarding-wrap">
							<div className="on-boarding-box box" style={{ width: "300px" }}>
								<div>
									<h2 className="page-title">Your Info</h2>
									{this.state.error && <div className="alert alert-danger">{this.state.error}</div>}
									<div>
										<Form
											id="activate-form"
											initialValues={this.state.user}
											onSubmit={this.createNewUserEmail}
										>
											<TextInput id="firstName" field="firstName" placeholder="First Name" />
											<TextInput id="lastName" field="lastName" placeholder="Last Name" />
											<SelectInput
												id="timeZoneId"
												field="timeZoneId"
												values={timezoneOptions}
												placeholder="Timezone"
												isRequired={true}
											/>
											<CheckBox id="optedIn" field="optedIn" label="Opt In" />
											<button type="submit" className="btn btn-primary wide">
												Finish
											</button>
										</Form>
									</div>
								</div>
								{
									// <div className="box-footer p-0">
									// 	<h5 className="page-title box-footer-btn" onClick={() => this.setState({existing: !this.state.existing})}>
									// 		<div className={`line-switch${!this.state.existing ? " on" : ""}`}>
									// 			<div className="line-switch-top">Or Sign Up</div>
									// 			<div className="line-switch-bottom"><i className="fal fa-chevron-left"></i> Log In</div>
									// 		</div>
									// 	</h5>
									// </div>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
Login.propTypes = {
	signInOptions: PropTypes.array,
	appName: PropTypes.string,
	iconUrl: PropTypes.string,
	iconAltText: PropTypes.string,
	auth: PropTypes.object,
	timezones: PropTypes.any,
};

function mapStateToProps(state) {
	return {
		auth: state.auth,
		timezones: state.controlPanel.timezones,
	};
}

export default connect(mapStateToProps)(Login);
